import React, { useEffect,useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SPORT_NAME_PREMATCH } from '../../config/markets';
import { format } from 'date-fns';
import { Translate } from '../../localization';
import { connect } from 'react-redux';
import { clearSearch } from '../../store/actions/resultsActions';
import OwlCarousel from 'react-owl-carousel2';

const options = {
    items: 10,
    navText: ['<div class=\'nav-btn prev-slide\'><i class="fas fa-chevron-left"></i></div>','<div class=\'nav-btn next-slide\'><i class="fas fa-chevron-right"></i></div>'],
    nav: true,
    dots: false,
    responsive:{
        1200:{
            items:10
        },
        1300:{
            items:11
        },
        1400:{
            items:10
        },
        1600:{
            items:10
        },
        1900:{
            items:10
        },
    }
};


const Filter = (props) => {
    const { sports, selectedSport, selectSport, clearSearch, isDisable, mainEvents, dateFilter, isHomeLeagueActive, noEvents, sportsObj, noSearchResults } = props;

    const handleChangeSport = (sportId) => {
        if (sportId === props.selectedSport) return null;
        selectSport(sportId);
        clearSearch();
    };

    const refElement = useRef();


    const [hoverId, setHoverId ] = useState();

  return (
      <div className="d-flex flex-wrap links-block w-100">
          { <div id='sport-filter' className="game-block w-100">
              { <ul className="d-flex">
                  <OwlCarousel
                        ref={refElement}
                        id='owl-demo'
                        options={ options }
                        onWheel={(e) =>{ if(e.deltaY > 0) {
                            refElement.current.next();
                        } else {
                            refElement.current.prev();
                        }}}
                    >
                      { Object.values(sports).map(item => {
                      let sportId = item.sport_id;
                      let sportName = item.name;
                      const className = !isHomeLeagueActive && sportId == selectedSport ? 'active' : '';
                      return (
                        
                          <li className={ className } onMouseOver={() => setHoverId(sportId)} onMouseLeave={() => setHoverId('')} onClick={ !isDisable ? (e) => handleChangeSport(sportId) : null } key={sportId}>
                              <a href >
                                  {/* <div className='sports__counter'> 20 </div> */}
                                  { sportId == selectedSport || sportId == hoverId ? <img alt="stream-icon" className="nav-ico-dark" src={`/images/sports/${item.icon_name}-desktop.svg`}></img>
                                   : <img alt="stream" className="nav-ico-light" src={`/images/sports/${item.icon_name}-desktop-white.svg`}></img> }
                                  <span>{sportName}</span>
                                  <span id={`sport-filter-${ sportId }`} />
                              </a>
                          </li>
                          
                      );
                  })}
                  </OwlCarousel>
              </ul>
            }
          </div>
        }
      </div>
    );
};

Filter.propTypes = {
    userData: PropTypes.object,
    setLanguage: PropTypes.func,
    language: PropTypes.string,
    headerClassname: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        dateFilter: state.today.dateFilter,
        selectedSport: state.results.selectedSport,
        mainEvents: state.results.mainEvents,
        noSearchResults: state.results.noSearchResults,
        language: state.general.language,
        isHomeLeagueActive: state.home.isHomeLeagueActive,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        clearSearch: () => dispatch(clearSearch()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);